
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/[product]/faq",
      function () {
        return require("private-next-pages/[company]/[product]/faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/[product]/faq"])
      });
    }
  